import type {
  CustomFieldValue,
  ProjectAudienceType,
} from '@freelancer/datastore/collections';

export const MAX_SKILLS_FILTER_COUNT = 5;
export const FILTER_DEBOUNCE_TIME = 500; // in ms

export enum AnalyticsWidget {
  GIGS_POSTED = 'gigs_posted',
  GIGS_AWARDED = 'gigs_awarded',
  UNAWARDED_PROJECTS = 'unawarded_projects',
  SPEND_OVER_TIME = 'spend_over_time',
  BID_AMOUNT = 'bid_amount',
  MEDIAN_BIDS_PER_GIG = 'median_bids_per_gig',
  USERS = 'users',
  HOURS_POSTED = 'hours_posted',
  AVERAGE_TIME_TO_AWARD = 'average_time_to_award',
  // T275672 Deloitte requested the Hire Talent location to be hidden
  // HIRE_TALENT_LOCATION = 'Hire talent location',
  // T291214 Deloitte requested this widget to be hidden, with the potential for it to be brought back in the near future
  // TOP_SKILLS_WITHIN_TALENT_CLOUD = 'top_skills_within_talent_cloud',
  TOP_SKILLS_FOR_INTERNAL_USERS = 'top_skills_for_internal_users',
  TOP_SKILLS_FOR_POSTED_PROJECTS = 'top_skills_for_posted_projects',
  NON_BILLABLE_VS_BILLABLE = 'non_billable_vs_billable',
  NPSI_SCORE = 'npsi_score',
}

export const ANALYTICS_WIDGET_DISPLAY_NAME_MAP: {
  readonly [W in AnalyticsWidget]: string;
} = {
  [AnalyticsWidget.GIGS_POSTED]: $localize`Gigs posted`,
  [AnalyticsWidget.GIGS_AWARDED]: $localize`Gigs awarded`,
  [AnalyticsWidget.UNAWARDED_PROJECTS]: $localize`Unawarded projects`,
  [AnalyticsWidget.SPEND_OVER_TIME]: $localize`Spend over time`,
  [AnalyticsWidget.BID_AMOUNT]: $localize`Bid Amount ($USD)`,
  [AnalyticsWidget.MEDIAN_BIDS_PER_GIG]: $localize`Median Bids per Gig`,
  [AnalyticsWidget.USERS]: $localize`Users`,
  [AnalyticsWidget.HOURS_POSTED]: $localize`Hours posted`,
  [AnalyticsWidget.AVERAGE_TIME_TO_AWARD]: $localize`Average time to award`,
  [AnalyticsWidget.TOP_SKILLS_FOR_INTERNAL_USERS]: $localize`Top skills within Deloitte`,
  [AnalyticsWidget.TOP_SKILLS_FOR_POSTED_PROJECTS]: $localize`Top skills for posted projects`,
  [AnalyticsWidget.NON_BILLABLE_VS_BILLABLE]: $localize`Non-billable vs billable`,
  [AnalyticsWidget.NPSI_SCORE]: $localize`NPSI Score`,
};

export interface StatsFilter {
  audience: readonly ProjectAudienceType[];
  jobIds?: readonly number[];
  beginDate?: Date;
  endDate?: Date;
  customFieldValues?: readonly CustomFieldValue[];
}

export interface ChecklistOption {
  readonly displayName: string;
  readonly value: string;
}

export enum FilterType {
  SKILLS = 'Skills',
  DATERANGE = 'Date range',
  ACCOUNTING_PERIOD = 'Accounting Period',
  PRACTICE = 'Practice',
  BUSINESS_LINE = 'Business Line',
  PROJECT_TYPE = 'Project Type',
  OFFERING_PORTFOLIO = 'Offering Portfolio',
  MARKET_OFFERING = 'Market Offering',
  AUDIENCE = 'Audience',
  ALL = 'All', // used to clear all filter
}

export enum StatsCardSize {
  MID = 'mid',
  SMALL = 'small',
}
